import { createSelector } from '@ngrx/store';
import { IDeliveryData } from '@partners/api';
import { IRootState } from '../../../root';
import { IDeliveryState } from './delivery.state';

export class DeliverySelectors {
  // todo: replace any type state with root state (once defined)
  static readonly deliveryState = (state: IRootState): IDeliveryState => {
    return state.delivery as IDeliveryState;
  };

  static readonly model = createSelector(DeliverySelectors.deliveryState, (delivery: IDeliveryState) => {
    return delivery.model;
  });

  static readonly data = createSelector(DeliverySelectors.deliveryState, (delivery: IDeliveryState) => {
    return delivery.data;
  });

  static readonly timeTable = createSelector(DeliverySelectors.data, (delivery: IDeliveryData) => {
    return delivery?.deliveryTimetable;
  });
}
